const getStyleForLoader = (theme) => {
  return {
    commonLoader: {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      top: 0,
      left: 0,
      zIndex: 20000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "white",
    },
    bgImageLoader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "196px",
    },
    logoSize: { width: "100%", marginBottom: "41px" },
  };
};

export const getLoaderStyle = getStyleForLoader;
